(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "ramda", "./constants"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("ramda"), require("./constants"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.ramda, global.constants);
    global.reducer = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _ramda, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.asyncReducer = asyncReducer;
  const ASYNC_ACTION_REGEX = /(.*)_(REQUEST|SUCCESS|FAILURE)/;

  function asyncReducer(state = {}, action) {
    if (!shouldHandleAction(action)) {
      return state;
    }

    const {
      type,
      payload
    } = action;
    const idKey = getIdKey(action);
    const {
      baseActionType,
      requestState
    } = decomposeActionType(type); // If an idKey has been supplied, it means each subsequent request should separately
    // track it's own request state.

    const asyncStateKey = !(0, _ramda.isNil)(idKey) ? `${baseActionType}_${payload[idKey]}` : baseActionType;
    return (0, _ramda.mergeDeepRight)(state, {
      [asyncStateKey]: {
        [_constants.LOADING_STATE_KEY]: isLoading(requestState),
        [_constants.ERROR_MESSAGE_KEY]: deriveErrorMessage(requestState, payload)
      }
    });
  }

  function shouldHandleAction(action) {
    const {
      type
    } = action;
    const actionTypeMatch = ASYNC_ACTION_REGEX.exec(type);
    const isAsyncAction = !(0, _ramda.isNil)(actionTypeMatch);
    return isAsyncAction;
  }

  function getIdKey(action) {
    return (0, _ramda.path)(['meta', 'idKey'], action);
  }

  function decomposeActionType(actionType) {
    const [, baseActionType, requestState] = ASYNC_ACTION_REGEX.exec(actionType);
    return {
      baseActionType,
      requestState
    };
  }

  function isLoading(requestState) {
    return requestState === 'REQUEST';
  }

  function deriveErrorMessage(requestState, payload) {
    if (requestState !== 'FAILURE') {
      return undefined;
    }

    return payload[_constants.ERROR_MESSAGE_KEY];
  }
});